import React from 'react';
import Navbar from './components/navbar/Navbar';
import './App.scss';
import Landing from './pages/landingPage/Landing';
import { Navigate, Route, Routes } from 'react-router-dom';
import {onAuthStateChanged} from 'firebase/auth';
import { auth, firestore } from './firebase/firebaseUtils';
import { onSnapshot,doc } from 'firebase/firestore';
import Spinner from './components/re-usable/spinner/Spinner';
import RequsetAlert from './components/re-usable/request-alert/RequsetAlert';

import { updateUser } from './redux/userReducer/userSlice';
import { useSelector,useDispatch } from 'react-redux';
import { selectCurrentUser } from './redux/userReducer/userSelector';
import Loader from './components/re-usable/loader/Loader';
const Signup = React.lazy(() => import ('./pages/register/Signup'))
const SignIn = React.lazy(() => import ('./pages/sign-in/SignIn'));
const ChatPage = React.lazy(() => import ('./pages/chatPage/ChatPage'));
const Help = React.lazy(() => import("./pages/help/Help"))
function App() {
  const currentUser = useSelector(state => selectCurrentUser(state));
  const dispatch = useDispatch();
  const loading = useSelector(state => state.loader.loading)
  

  React.useEffect( () => {
    let unSubscribeFromAuth = null;
      unSubscribeFromAuth =  onAuthStateChanged( auth, async user => {
        if(user) {
        onSnapshot(doc(firestore,'users',`${user.uid}`), snapshot => {
          dispatch(updateUser({
            ...snapshot.data()
          }))
        })
       
        }
        else{
          dispatch(updateUser(null));
        }

      })
      return () => unSubscribeFromAuth();
  },[dispatch])
  return (
 <>
 
 <Navbar  />
<RequsetAlert />
 <React.Suspense fallback={<Spinner />}>
 {loading ?<Loader /> :""} 
 <Routes>
  <Route index path='/'  element={<Landing />} />
  <Route path='/sign-up' element={currentUser ?<Navigate to='/chat' replace />:<Signup />} />
  <Route path='/sign-in' element={currentUser ?<Navigate to='/chat' replace />:<SignIn currentUser={currentUser} />} />
  <Route path='/chat' element={currentUser ?<ChatPage currentUser={currentUser} />:<Navigate to='/sign-in' />}  />
  <Route path="/help" element={<Help />} />
 </Routes>
 </React.Suspense>
    

 
 </>
  );
}

export default App;
